import React, { Component } from 'react';
import PropTypes from 'prop-types';
import SVGElement from './SVGElement';
import colors from '../../styling/colors';

export default class Close extends Component {
  static propTypes = {
    className: PropTypes.string,
    height: PropTypes.string,
    strokeColor: PropTypes.string,
    width: PropTypes.string,
  };

  static defaultProps = {
    height: '1.5rem',
    strokeColor: colors('Lapel'),
    width: '1.5rem',
  };

  render() {
    const { className, height, strokeColor, width } = this.props;

    return (
      <SVGElement
        className={className}
        height={height}
        viewBox="0 0 24 24"
        width={width}
      >
        <g id="Symbols" fill="none" fillRule="evenodd">
          <g id="x" fill={strokeColor}>
            <g id="Group-6" transform="translate(1 1)">
              <path
                d="M12.1607965,11.3484095 L21.032967,2.47623902 L19.6402524,0.990676768 L10.8197265,9.81120267 L1.99920062,0.990676768 L0.606486003,2.47623902 L9.4786565,11.3484095 L0.606486003,20.22058 L1.99920062,21.7061423 L10.8197265,12.8856164 L19.6402524,21.7061423 L21.032967,20.22058 L12.1607965,11.3484095 Z"
                id="Combined-Shape"
              />
            </g>
          </g>
        </g>
      </SVGElement>
    );
  }
}
